import { useMemo } from "react";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import addMinutes from "date-fns/addMinutes";

import { UseDatePickerField } from "./types";

export const useDatePickerField: UseDatePickerField = ({
  value,
  utc,
  onChange,
}) =>
  useMemo(
    () => ({
      value: (() => {
        if (!value) {
          return undefined;
        }

        const dateValue = new Date(value);

        if (!utc) {
          return dayjs(dateValue);
        }

        const dateUTC = addMinutes(dateValue, dateValue.getTimezoneOffset());

        return dayjs(dateUTC);
      })(),
      onChange(newDateDayjs: Dayjs | null) {
        if (!newDateDayjs) {
          onChange?.(undefined);

          return;
        }

        const newDateValue = newDateDayjs.toDate();

        if (!utc) {
          onChange?.(newDateValue.toISOString());

          return;
        }

        const newDateUTC = addMinutes(
          newDateValue,
          -newDateValue.getTimezoneOffset()
        );

        onChange?.(newDateUTC.toISOString());
      },
    }),
    [onChange, utc, value]
  );
